import SockJS from 'sockjs-client' // eslint-disable-line import/extensions
import Stomp from 'stompjs'

// import { saveStompClient } from '../actions/SkuList'
import { getRequestConfig, webRequest } from '../utils/requests'

export default (dispatch, onConnected, onError) => {
  try {
    // const saveStompClient = stompClient => {
    //   console.log('saveStompClient')
    //   return { type: 'SAVE_STOMP_CLIENT', stompClient }
    // }

    /* Retrieve the correct endpoint for starting the socket connection */
    const service = getRequestConfig('socketConnect')
    console.log('socketConnect Api Action', service)

    /* Returns a new SockJS object that conforms to the WebSocket definition */
    const socket = new SockJS(webRequest(service))

    console.log('initialize stomp client')

    /* Create a Stomp client based on the SockJS object */
    const stompClient = Stomp.over(socket)

    // dispatch(saveStompClient(stompClient))

    console.log('SetupSocket : After connect')
    stompClient.connect({}, onConnected, onError)
    return stompClient
  } catch (e) {
    console.error('stompSocketService issue: ', e)
    return e
  }
}



// WEBPACK FOOTER //
// ./src/services/stompSocketService.js